import { Component, Input } from '@angular/core';
import { SelectableComponent } from '../../../../../shared/components/group-selection/selectable/selectable.component';
import { TemplateCollectionDomainModel } from '../../../../../../domainModels/template-collection-domain-model';
import type { Display } from '../../../../../../models/display/dto/display';

@Component({
  selector: 'app-location-display-selection-item',
  templateUrl: './location-display-selection-item.component.html',
  styleUrls: ['./location-display-selection-item.component.scss'],
  standalone: false
})
export class LocationDisplaySelectionItemComponent extends SelectableComponent {
  constructor(private collectionDomainModel: TemplateCollectionDomainModel) {
    super();
  }

  @Input() override selection: Display;
  @Input() last: boolean = false;
}
